import React from 'react'
import 'nprogress/nprogress.css'
import { Switch, Route, Redirect } from 'react-router-dom'

import Header from './Header'

import { AppProps } from '../containers/ConnectedApp'
import ConnectedMenu from '../containers/ConnectedMenu'
import ConnectedScanner from '../containers/ConnectedScanner'
import ConnectedProduct from '../containers/ConnectedProduct'
import ConnectedPromotionalProduct from '../containers/ConnectedPromotionalProduct'
import ConnectedMessage from '../containers/ConnectedMessage'

const App: React.FC<AppProps> = props => (
	<div className="background background--fullscreen background--secondary">
		<Header locale={props.locale} setLocale={props.setLocale} />

		<Switch>
			<Route path="/" exact component={ConnectedMenu} />
			<Route path="/product/:barcode" exact component={props.showPromotionalPage === false ? ConnectedProduct : ConnectedPromotionalProduct} />
			<Route path="/scanner" component={ConnectedScanner} />
			<Redirect to="/" />
		</Switch>

		<ConnectedMessage />
	</div>
)

export default App
